// src/api/request.js
import axios from 'axios';
import {
  ElMessage
} from 'element-plus';
import {
  ref
} from 'vue';

// 存储请求的列表
const pendingRequests = new Set();

// 判断调试台是否打开的函数
const isDevToolsOpen = () => {
  const startTime = performance.now();
  debugger;
  const endTime = performance.now();
  return endTime - startTime > 100;
}

const cs5 = "http://localhost:9005/"
const cs3 = "http://localhost:9003/"
const baseUrlZcy = "https://lxxapi.lanxiaoxiao.com/"
const createAxiosInstance = (router) => {
  const http = axios.create({
    baseURL: baseUrlZcy, // 基础URL
    timeout: 25 * 1000, // 请求超时时间
  });

  // 请求拦截器
  http.interceptors.request.use(
    config => {
      // if (isDevToolsOpen()) {
      //   // 调试台打开，给出消息提示
      //   ElMessage.error('正在调试中，暂无法访问')
      //   // 拦截请求，返回一个被拒绝的 Promise
      //   // throw new Error('调试台已打开，请求被拦截');
      //   // return
      //   return new Promise(() => {});
      // }
      // 添加认证token
      if (localStorage.getItem('token')) {
        config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
      }
      // config.headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";

      // 生成请求唯一标识
      const requestKey = `${config.method}:${config.url}`;

      // 如果请求已存在，取消当前请求
      if (pendingRequests.has(requestKey)) {
        return new Promise(() => {});
      }

      // 将请求添加到列表中
      pendingRequests.add(requestKey);

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  http.interceptors.response.use(
    response => {
      // 生成请求唯一标识
      const requestKey = `${response.config.method}:${response.config.url}`;

      // 请求完成后从列表中移除
      pendingRequests.delete(requestKey);

      
      return response.data;
    },
    error => {
      if (error.config) {
        // 生成请求唯一标识
        const requestKey = `${error.config.method}:${error.config.url}`;
        
        // 请求出错后从列表中移除
        pendingRequests.delete(requestKey);
      }
      // ✅ 修复：使用 error.response，判断http状态码401
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        ElMessage.warning('账号登录过期，请重新登录！');
        router.push('/login');
      }
      console.log(error, "error");
      return Promise.reject(error);
    }
  );

  return http;
};

export default createAxiosInstance;
